export default __webpack_public_path__ + "static/media/debit-interest-types.34097f4f.svg";